export const SCREENSHOT_WIDTH = 739;
export const SCREENSHOT_HEIGHT = 1600;

export const SYSTEM_SHOWCASE_SCREENS = Array.from({ length: 9 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0");

  return {
    src: `/images/tela${number}.jpeg`,
    alt: `Tela ${index + 1} do aplicativo Meu Barbeiro Pro`,
  };
});

export const SHOWCASE_AUTOPLAY_MS = 6000;
export const SHOWCASE_SLIDE_GAP_PX = 20;
